__turbopack_context__.v({
  "button": "InputSearchAdvanced-module-scss-module__Az5YmG__button",
  "closeButton": "InputSearchAdvanced-module-scss-module__Az5YmG__closeButton",
  "combobox": "InputSearchAdvanced-module-scss-module__Az5YmG__combobox",
  "comboboxOpen": "InputSearchAdvanced-module-scss-module__Az5YmG__comboboxOpen",
  "fade-in": "InputSearchAdvanced-module-scss-module__Az5YmG__fade-in",
  "groupLabel": "InputSearchAdvanced-module-scss-module__Az5YmG__groupLabel",
  "header": "InputSearchAdvanced-module-scss-module__Az5YmG__header",
  "iconLabel": "InputSearchAdvanced-module-scss-module__Az5YmG__iconLabel",
  "input": "InputSearchAdvanced-module-scss-module__Az5YmG__input",
  "inputWrapper": "InputSearchAdvanced-module-scss-module__Az5YmG__inputWrapper",
  "list": "InputSearchAdvanced-module-scss-module__Az5YmG__list",
  "loader": "InputSearchAdvanced-module-scss-module__Az5YmG__loader",
  "no-transform": "InputSearchAdvanced-module-scss-module__Az5YmG__no-transform",
  "option": "InputSearchAdvanced-module-scss-module__Az5YmG__option",
  "optionActive": "InputSearchAdvanced-module-scss-module__Az5YmG__optionActive",
  "optionCount": "InputSearchAdvanced-module-scss-module__Az5YmG__optionCount",
  "rotate": "InputSearchAdvanced-module-scss-module__Az5YmG__rotate",
  "searchHistoryOption": "InputSearchAdvanced-module-scss-module__Az5YmG__searchHistoryOption",
  "searchHistoryOptionLink": "InputSearchAdvanced-module-scss-module__Az5YmG__searchHistoryOptionLink",
  "searchHistoryOptionLinkActive": "InputSearchAdvanced-module-scss-module__Az5YmG__searchHistoryOptionLinkActive",
  "searchHistoryOptionRemoveButton": "InputSearchAdvanced-module-scss-module__Az5YmG__searchHistoryOptionRemoveButton",
});
